import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import { Contract, BasicComponent, Address } from "./edp-contract.model";
import { Subscription } from "rxjs/Subscription";
import { ContractService } from "@edp-services/contract.service";
import { Pack } from "@edp-components/edp-pack";

declare function bysideWebcare_triggerevent(code: number): void;

@Component({
    selector: "edp-contract",
    templateUrl: "./edp-contract.component.html",
    styleUrls: ["./edp-contract.component.scss"],
})
export class EdpContractComponent implements OnInit, OnDestroy {
    public address: Address;
    public eletricityBasicComponent: BasicComponent;
    public gasBasicComponent: BasicComponent;
    public type: string;
    public colorPack = "nopack";
    public hoverPack = "hover-nopack";

    @Input() pack: Pack;
    @Input() contract: Contract;
    @Input() isSingleContract: boolean;
    @Input() isSwipe: boolean;
    @Input() selected = false;

    private readonly GAS_TYPE: string = "G";
    private readonly ELETRICITY_TYPE: string = "E";
    private subscription: Subscription;

    constructor(
        private contractService: ContractService
    ) {}

    ngOnInit() {
        this.type =  this.contract.getType();

        if (this.pack && this.pack.type) {
            this.packsColor();
        }

        this.gasBasicComponent = this.contract.getBasicComponentByType(this.GAS_TYPE);
        this.eletricityBasicComponent = this.contract.getBasicComponentByType(this.ELETRICITY_TYPE);
        this.address = this.contract.getBasicComponentAddress(0);
        this.subscription = this.contractService.contractChanged$.subscribe((contract: Contract) => {
            this.selected = contract.ContractId === this.contract.ContractId;
        });

        if (this.isSingleContract === true) {
            this.selectContract(this.contract);
        }
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    public selectContract(contract: Contract): void {
        if (!this.isSwipe) {
            if (contract.Disabled) {
                switch (this.pack.type) {
                    case 1:
                        bysideWebcare_triggerevent(13092);
                        break;
                    case 2:
                        bysideWebcare_triggerevent(13116);
                        break;
                    case 3:
                        bysideWebcare_triggerevent(13118);
                        break;
                    default:
                        bysideWebcare_triggerevent(13328);
                        break;
                }
            } else {
                this.contractService.contractChanged$.next(contract);
            }
        }
    }

    packsColor() {
        switch (this.pack.type) {
            case 1:
                this.colorPack = "color-easy";
                this.hoverPack = "hover-easy";
                break;
            case 2:
                this.colorPack = "color-smart";
                this.hoverPack = "hover-smart";
                break;
            case 3:
                this.colorPack = "color-full";
                this.hoverPack = "hover-full";
                break;
            default:
                this.colorPack = "nopack";
                this.hoverPack = "hover-nopack";
                break;
        }
    }
}
